// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "login" : chunkId) + "." + {"552":"8e00e405","565":"797961c1","640":"126f03d0","736":"9bca8982","858":"5630f48d","966":"43c81f81"}[chunkId] + ".js";
};